<template>
  <modal :title="$t('titles.product')">
    <!-- Currently selected product-->
    <base-row class="bg-grey-lighter">
      <div class="md:flex-shrink-0 w-1/5">
        <img
          class="rounded-lg"
          :class="$style['fit-image']"
          :src="$store.state.product.info.images.front.src"
          alt=""
        />
      </div>
      <div class="ml-4 flex-grow self-center leading-normal">
        <div class="text-sm text-indigo-600">
          {{ $t('product.currentlySelected') }}:
        </div>
        <div class="">
          <p class="font-semibold text-gray-900">
            {{ $store.state.product.info.title }}
          </p>
        </div>
      </div>
    </base-row>
    <menu-item to="product-change">
      {{ $t('product.change') }}
    </menu-item>

    <menu-item to="product-color">
      <div class="flex items-center justify-between">
        <div>
          {{ $t('product.color') }}
        </div>
        <div v-if="selectedColor" class="flex mr-2 items-center">
          <swatch
            :id="selectedColorId"
            :label="selectedColor.label"
            :hex="selectedColor.hex"
            class="w-8 mr-2"
          />
          <span>{{ selectedColor.label }}</span>
        </div>
      </div>
    </menu-item>

    <menu-item
      :collapsable="true"
      @click.native="
        trackPath({
          virtPath: 'product',
          contentGroup2: 'Creator_Product',
          contentGroup3: 'Creator_ProductDetails'
        })
      "
    >
      {{ $t('product.details') }}
      <div slot="collapsable" class="flex flex-col ml-2">
        <h4>{{ $t('product.description') }}</h4>
        <!-- eslint-disable vue/no-v-html -->
        <div v-html="$store.state.product.info.description"></div>
        <!-- eslint-enable vue/no-v-html -->
        <div
          v-for="(productDetail, key) of $store.state.product.info.details"
          :key="key"
          class="flex-col relative flex justify-left"
        >
          <h4>{{ $t('product.' + key) }}</h4>
          <!-- eslint-disable vue/no-v-html -->
          <div v-html="productDetail.data"></div>
          <!-- eslint-enable vue/no-v-html -->
        </div>
      </div>
    </menu-item>
  </modal>
</template>
<script>
import Modal from '../../components/Modal.vue';
import MenuItem from '../../components/MenuItem.vue';
import Swatch from '../../components/Swatch.vue';
import { TrackingMixin } from '../../mixins/gtm-tracking';

export default {
  name: 'ProductMenu',
  components: {
    MenuItem,
    Modal,
    Swatch
  },
  mixins: [TrackingMixin],
  computed: {
    selectedColorId() {
      return this.$store.getters['product/selectedColor'];
    },
    selectedColor() {
      return this.$store.getters['product/availableColors'].find(
        color => color.id === this.selectedColorId
      );
    }
  }
};
</script>
<style module>
.fit-image {
  max-height: 100%;
  max-width: 100%;
}
</style>
